module.exports = __webpack_public_path__ + "img/white.18d0cbc8.png";